import { memo } from "react";

import { FeatureIslandCategoryQuestionForMain } from "@/components/features/_layouts/island/main-with-category/components/category-main-question";

import { InputTextField } from "@/components/ui/form/fields/input-field/input-text";

import { usePlanName } from "./hooks";

export const QuestionPlanName = memo(() => {
	const { name, onSetName } = usePlanName();

	const onChange = (value: string) => {
		onSetName(value);
	};

	return (
		<FeatureIslandCategoryQuestionForMain
			required={true}
			title="プラン名"
			guide="他のプランとの違いがわかりやすい名前にしましょう。日本語の場合30文字まで入力ができます。"
			isEdited={name.isEdited}
			hasError={Boolean(name.error)}
			inputChildren={<InputTextField errorMessage={name.error} value={name.value} handleChange={onChange} />}
		/>
	);
});

QuestionPlanName.displayName = "QuestionPlanName";
